import { cn } from '@/lib/utils';
import React from 'react';
interface SectionTagProps {
  children: React.ReactNode;
  className?: string;
}
export function SectionTag({
  children,
  className = ''
}: SectionTagProps) {
  return <span className={cn('inline-block rounded-full border border-gold/40 bg-ivory px-4 py-1.5 text-[0.65rem] font-bold uppercase tracking-editorial text-gold-deep', className)} data-id="element-230" data-mp="20qn43vjj7afr">
      {children}
    </span>;
}